/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PhotoContainer_tradePhoto = {
    readonly path: string | null;
    readonly height: number | null;
    readonly width: number | null;
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"ItemTagOverlay_tradePhoto" | "SocialIconOverlay_photo">;
    readonly " $refType": "PhotoContainer_tradePhoto";
};
export type PhotoContainer_tradePhoto$data = PhotoContainer_tradePhoto;
export type PhotoContainer_tradePhoto$key = {
    readonly " $data"?: PhotoContainer_tradePhoto$data;
    readonly " $fragmentRefs": FragmentRefs<"PhotoContainer_tradePhoto">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PhotoContainer_tradePhoto",
  "type": "TradePhoto",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "height",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "width",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ItemTagOverlay_tradePhoto",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SocialIconOverlay_photo",
      "args": null
    }
  ]
};
(node as any).hash = '8921ec0a3482dd32b3ded568b54358e4';
export default node;
